// Shared admin formatting helpers.
export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB");
  } catch {
    return iso;
  }
};
